import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withFormsy } from 'formsy-react';

class ValidatingCheckbox extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        checked: PropTypes.bool,
        onClick: PropTypes.func,
        name: PropTypes.string,
        children: PropTypes.node,
        disabled: PropTypes.bool
    };

    handleOnClickCheckbox = () => {
        const {disabled, onClick} = this.props;
        if (disabled) {
            return;
        }
        onClick();
    }

    render() {
        const checkboxClasses = classNames(
            'checkbox-view',
            {'highlight-border': this.props.checked},
            {highlight: this.props.checked},
            {disabled: this.props.disabled},
        );
        return (
            <div className="checkbox-container">
                <input
                    id={this.props.id}
                    className="form-control-checkbox"
                    type="checkbox"
                    readOnly
                    name={this.props.name}
                    checked={this.props.checked}
                     />
                <label className="form-label" onClick={this.handleOnClickCheckbox} htmlFor={this.props.id}>
                    <div className="checkbox-view-container">
                        <span className={checkboxClasses}>
                            <b className="icon-checkbox checkbox-checked" />
                            <b className="icon-checkbox-unchecked checkbox-unchecked" />
                        </span>
                    </div>
                    <div className="checkbox-label-content">
                        {this.props.children}
                    </div>
                </label>
            </div>
        );
    }
}

export default withFormsy(ValidatingCheckbox);
